import React, { Component } from "react";
import TableComponent from './TableComponent';
// import TaskCreationRule from './TaskCreationRule'
import { Icon, Switch, FormControlLabel, IconButton, withStyles, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import FontAwesome from 'react-fontawesome'
// import CreateNewFieldTaskDialog from "./CreateNewFieldTaskDialog";
import * as actions from '../../../store/actions/index';
import { connect } from "react-redux";
import { compose } from 'redux';

const IconSmall = withStyles(() => ({
    root: {
        fontSize: "1.5rem",
    }
}))(Icon);

class RelatedSettingLead extends Component {

    constructor(props) {
        super(props);

        this.state = {
            leaddata: [],
            leadFieldIds: [],
            leadOrderIds: [],
            activedatas: [],
            inactivedatas: [],
            shouldOpenCreateFieldTaskDialog: false,
            updatelistorder: true,
        };
    }

    

    componentDidMount() {
        let val = { recordtypeid: 1 }
        this.props.getRelatedMasterList(this.props.apolloClient.client, val);
        // this.props.customFieldTypeList(this.props.apolloClient.client);
    }

    componentWillReceiveProps(props) {
        if (props.settingReducer.leadrelatedMaster.data) {
            const leadrelatedMaster = props.settingReducer.leadrelatedMaster.data;
            let activedatas = [];
            let inactivedatas = [];
            let leadFieldIds = [];
            let leadOrderIds = [];

            leadrelatedMaster.map((fieldData, index) => {
                
                let fieldlicon = (fieldData.icon === 'fa-dollar-sign') ? 'fa-usd' : fieldData.icon;
                if (fieldData.isactive === true) {
                    leadFieldIds.push(parseFloat(fieldData.id));
                    leadOrderIds.push(parseFloat(fieldData.orderno));

                    activedatas.push({
                        drag: <Link className="drag-handle" leadOrderIds={leadOrderIds} to="#"><Icon>drag_handle</Icon></Link>,
                        key: fieldData.id,
                        name: (
                            <div>
                                <FontAwesome className={'crm-fontawsome-icon ' + fieldlicon} ></FontAwesome>
                                <label className="crm-custom-field-label">{fieldData.name}</label>
                            </div>
                        ),
                        action: <React.Fragment>
                            <IconButton onClick={(id) => this.handleUpdateStatus(fieldData.id, false)}><Icon>remove_circle_outline_icon</Icon></IconButton>
                        </React.Fragment>
                    })
                }

                if (fieldData.isactive === false) {
                    inactivedatas.push({
                        key: fieldData.id,
                        name: (
                            <div>
                                <FontAwesome className={'crm-fontawsome-icon ' + fieldlicon} ></FontAwesome>
                                <label className="crm-custom-field-label">{fieldData.name}</label>
                            </div>
                        ),
                        action: <React.Fragment>
                            <IconButton onClick={(id) => this.handleUpdateStatus(fieldData.id, true)}><Icon>add_circle_outline_icon</Icon></IconButton>
                        </React.Fragment>
                    })
                }
            })

            if(this.state.updatelistorder == true)
                this.setState({ activedatas: activedatas, inactivedatas: inactivedatas, leadFieldIds: leadFieldIds, leadOrderIds: leadOrderIds }, () => this.forceUpdate());
        }
    }

    closePopUp = () => {
        this.setState({ shouldOpenCreateFieldTaskDialog: false });
    }
    handleUpdateStatus = (id, status) =>{
        let val = {
            status: status,
            relatedid: parseFloat(id),
            recordtypeid:1,
        }

        this.props.updateRelatedStatus(this.props.apolloClient.client, val);
    }

    updateFieldsOrder = (fromIndex, toIndex) => {

        let leadFieldIds = [];

        const leaddata = this.state.activedatas;
        const item = leaddata.splice(fromIndex, 1)[0];

        leaddata.splice(toIndex, 0, item);

        this.setState({
            leaddata: leaddata,
            updatelistorder:false,
        })
        const leadOrderIds = this.state.leadOrderIds;
        leaddata.map((value, index) => {
            leadFieldIds.push(parseFloat(value.key));
        });

        let val1 = {
            orderno: leadOrderIds,
            relatedid: leadFieldIds,
            recordtypeid: 1,
        }
        this.props.updateRelatedOrder(this.props.apolloClient.client, val1);
    }
    handleTaskDialogClose = () => {
        this.setState({ shouldOpenCreateFieldTaskDialog: false });
    };
    render() {
        let { shouldOpenCreateFieldTaskDialog } = this.state;
        return (
            <>
                <TableComponent activedata={this.state.activedatas} inActivedata={this.state.inactivedatas} allData={this} />
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        settingReducer: state.settingReducer,
        apolloClient: state.apolloClient
    };
};
const mapDispatchToProps = dispatch => {
    return {
        
        getRelatedMasterList: (client, request) => { dispatch(actions.getRelatedMasterList(client, request)) },
        customFieldList: (client, request) => { dispatch(actions.customFieldList(client, request)) },
        customFieldTypeList: (client) => { dispatch(actions.customFieldTypeList(client)) },
        updateRelatedStatus: (client, request) => { dispatch(actions.updateRelatedStatus(client, request)) },
        updateRelatedOrder: (client, request) => { dispatch(actions.updateRelatedOrder(client, request)) },

    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(RelatedSettingLead);
